import { render } from "./CLoading.vue?vue&type=template&id=9a647cb4&scoped=true"
const script = {}

import "./CLoading.vue?vue&type=style&index=0&id=9a647cb4&lang=scss&scoped=true"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a647cb4"]])

export default __exports__